import React, { useState } from "react";
import "styles/ScoringCriteria.css";

const ScoringCriteria = () => {
  const [
    scoringCriteriaGovernanceOfESGAwardsContent,
    setScoringCriteriaGovernanceOfESGAwardsContent,
  ] = useState([
    {
      title: "ESG Governance & Policy",
      isOpenDescription: false,
      description:
        "The extent to which the organization has established a clear, formal, and effective ESG governance framework, including leadership commitment, defined policies and charters, board-level oversight, assigned roles and accountability, integration of sustainability into corporate values and decision-making, and the incorporation of ESG competencies within board responsibilities, capabilities, and succession planning.",
    },
    {
      title: "ESG Risk & Materiality",
      isOpenDescription: false,
      description:
        "The extent to which ESG initiatives are governed through appropriate board-level oversight or dedicated steering committees, with clearly defined project governance structures, roles, and accountabilities—particularly for project sponsors and project managers—aligned with recognized ISO and PMBOK project governance frameworks.",
    },
    {
      title: "ESG Performance & Communication",
      isOpenDescription: false,
      description:
        "The extent to which ESG considerations are systematically integrated across all phases of the project lifecycle—from initiation and planning to execution and monitoring—and are embedded within project risk management practices, including the identification, assessment, and management of ESG-related risks in accordance with recognized standards such as ISO 21500 and ISO 31000.",
    },
  ]);

  const [
    scoringCriteriaProjectManagementOfESGInitiativeAwardContent,
    setScoringCriteriaProjectManagementOfESGInitiativeAwardContent,
  ] = useState([
    {
      title: "Strategic Alignment & Clear Objectives",
      isOpenDescription: false,
      description:
        "The extent to which ESG goals are strategically aligned with the organization’s overall business strategy and value creation objectives, and are defined in a structured, SMART manner—ensuring clarity, measurability, feasibility, relevance, and time-bound execution in line with recognized project and management standards.",
    },
    {
      title: "Governance & Leadership",
      isOpenDescription: false,
      description:
        "The extent to which ESG initiatives are governed through appropriate board-level oversight or dedicated steering committees, with clearly defined project governance structures, roles, and accountabilities—particularly for project sponsors and project managers—aligned with recognized ISO and PMBOK project governance frameworks.",
    },
    {
      title: "ESG Integration into Processes & Risk Management",
      isOpenDescription: false,
      description:
        "The extent to which ESG considerations are systematically integrated across all phases of the project lifecycle—from initiation and planning to execution and monitoring—and are embedded within project risk management practices, including the identification, assessment, and management of ESG-related risks in accordance with recognized standards such as ISO 21500 and ISO 31000.",
    },
    {
      title: "Metrics, Monitoring & Reporting",
      isOpenDescription: false,
      description:
        "The extent to which ESG-related projects or initiatives define and track clear, measurable KPIs aligned with recognized sustainability frameworks (e.g., GRI, SASB), and are subject to regular internal or external reviews, audits, and quality assurance processes in line with ISO 21500 and PMBOK control and assurance practices.",
    },
    {
      title: "Stakeholder Engagement & Ethical Governance",
      isOpenDescription: false,
      description:
        "The extent to which ESG projects or initiatives actively engage relevant stakeholders—including internal teams, communities, and partners—throughout planning and decision-making processes, while upholding ethical governance, social responsibility, transparency, and accountability in alignment with ISO 21500 stakeholder management guidance, GPM ESG principles, and ISO 26000 standards.",
    },
    {
      title: "Benefit Realization & Value Creation",
      isOpenDescription: false,
      description:
        "The extent to which the ESG project or initiative systematically monitors, measures, and reports its direct impacts on the organization’s business performance, value creation, and risk profile, ensuring that ESG outcomes are clearly linked to operational, financial, and strategic results.",
    },
    {
      title: "Project Governance & Decision Framework",
      isOpenDescription: false,
      description:
        "The extent to which the ESG project or initiative applies robust and structured decision-making frameworks, supported by clear project charters, escalation pathways, and governance mechanisms, while maintaining comprehensive and systematic documentation—such as business cases, risk registers, and communication logs—in alignment with ISO 21500, PMBOK, and GPM standards.",
    },
  ]);

  const handleOnClickScoringCriteria = (criteria, key) => {
    let finalCriteriaContent =
      key && key === "Governance"
        ? scoringCriteriaGovernanceOfESGAwardsContent
        : scoringCriteriaProjectManagementOfESGInitiativeAwardContent;
    finalCriteriaContent = finalCriteriaContent.map((eachCriteria) => {
      if (criteria && eachCriteria && eachCriteria.title === criteria.title) {
        eachCriteria = {
          ...eachCriteria,
          isOpenDescription: !eachCriteria.isOpenDescription,
        };
      }
      return eachCriteria;
    });

    const setter =
      key && key === "Governance"
        ? setScoringCriteriaGovernanceOfESGAwardsContent
        : setScoringCriteriaProjectManagementOfESGInitiativeAwardContent;

    setter(finalCriteriaContent);
  };

  return (
    <section className="scoring-criteria-section">
      <div className="container">
        <h2 className="section-title">Scoring Criteria</h2>

        {/* Governance of ESG Award */}
        {scoringCriteriaGovernanceOfESGAwardsContent &&
        Array.isArray(scoringCriteriaGovernanceOfESGAwardsContent) &&
        scoringCriteriaGovernanceOfESGAwardsContent.length ? (
          <div className="criteria-card">
            <div className="card-header">
              <div className="award-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="award-title">Governance of ESG Award</h3>
            </div>
            <div className="card-body">
              <h4 className="criteria-subtitle">Scoring Criteria:</h4>
              <ul className="criteria-list">
                {scoringCriteriaGovernanceOfESGAwardsContent.map(
                  (eachCriteria, idx) => {
                    const { title, isOpenDescription, description } =
                      eachCriteria || {};
                    if (isOpenDescription) {
                      return (
                        <div
                          className="assessment-section"
                          onClick={() =>
                            handleOnClickScoringCriteria(
                              eachCriteria,
                              "Governance",
                            )
                          }
                          key={idx}
                        >
                          <div className="assessment-header">
                            <h4 className="assessment-title">{title}</h4>
                          </div>
                          <ol className="sub-criteria-list">
                            <span className="criteria-text">{description}</span>
                          </ol>
                        </div>
                      );
                    } else {
                      return (
                        <li
                          className="criteria-item"
                          onClick={() =>
                            handleOnClickScoringCriteria(
                              eachCriteria,
                              "Governance",
                            )
                          }
                          key={idx}
                        >
                          <span className="bullet"></span>
                          <span className="criteria-text">{title}</span>
                        </li>
                      );
                    }
                  },
                )}
              </ul>
            </div>
          </div>
        ) : null}

        {/* Project Management of ESG Initiative Award */}
        {scoringCriteriaProjectManagementOfESGInitiativeAwardContent &&
        Array.isArray(
          scoringCriteriaProjectManagementOfESGInitiativeAwardContent,
        ) &&
        scoringCriteriaProjectManagementOfESGInitiativeAwardContent.length ? (
          <div className="criteria-card">
            <div className="card-header">
              <div className="award-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="award-title">
                Project Management of ESG Initiative Award
              </h3>
            </div>
            <div className="card-body">
              <h4 className="criteria-subtitle">Scoring Criteria:</h4>
              <ol className="criteria-list">
                {scoringCriteriaProjectManagementOfESGInitiativeAwardContent.map(
                  (eachCriteria, idx) => {
                    const { title, isOpenDescription, description } =
                      eachCriteria || {};
                    if (isOpenDescription) {
                      return (
                        <div
                          className="assessment-section"
                          onClick={() =>
                            handleOnClickScoringCriteria(eachCriteria)
                          }
                          key={idx}
                        >
                          <div className="assessment-header">
                            <h4 className="assessment-title">{title}</h4>
                          </div>
                          <ol className="sub-criteria-list">
                            <span className="criteria-text">{description}</span>
                          </ol>
                        </div>
                      );
                    } else {
                      return (
                        <li
                          className="criteria-item"
                          onClick={() =>
                            handleOnClickScoringCriteria(eachCriteria)
                          }
                          key={idx}
                        >
                          <span className="bullet"></span>
                          <span className="criteria-text">{title}</span>
                        </li>
                      );
                    }
                  },
                )}
              </ol>
            </div>
          </div>
        ) : null}

        {/* Total Scoring */}
        {/* <div className="criteria-card highlight-card">
          <div className="card-header">
            <div className="award-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3 className="award-title">Total Scoring</h3>
          </div>
          <div className="card-body">
            <div className="assessment-section">
              <div className="assessment-header">
                <h4 className="assessment-title">
                  1st Assessment: Administrative
                </h4>
                <span className="assessment-percentage">50%</span>
              </div>
              <ol className="sub-criteria-list">
                <li className="sub-criteria-item">
                  <span className="criteria-text">
                    Completion of Yes/No answer
                  </span>
                  <span className="percentage">10%</span>
                </li>
                <li className="sub-criteria-item">
                  <span className="criteria-text">
                    Completion of Evidence Document
                  </span>
                  <span className="percentage">45%</span>
                </li>
                <li className="sub-criteria-item">
                  <span className="criteria-text">
                    Completion of Explanation
                  </span>
                  <span className="percentage">45%</span>
                </li>
              </ol>
            </div>

            <div className="assessment-section">
              <div className="assessment-header">
                <h4 className="assessment-title">
                  2nd Assessment: Judging Panel Online Interview
                </h4>
                <span className="assessment-percentage">50%</span>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="note-card">
          <p className="note-text">
            <strong>Note:</strong> All percentages represent the weight of each
            criterion in the final scoring evaluation. Participants must
            complete all requirements to be eligible for the awards.
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default ScoringCriteria;
